interface ChevronRightIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export default function ChevronRightIcon({
  width = 7,
  height = 13,
  color = 'currentColor',
  className,
}: ChevronRightIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 7 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1.0999 1.69995L5.8999 6.49995L1.0999 11.3"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
